import React, { useState } from 'react';
import './_multiImages.scss';
import { IoStar, IoTrash, IoCloudUpload } from 'react-icons/io5';
import ImageViewer from '../imageViewer/ImageViewer';

function MultiImages({ images, onSetPrimary, onDelete, onUpload, loading, errors, readOnly = false, title = 'Images' }) {
  const [viewerOpen, setViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleFileChange = (e) => {
    if (onUpload && !readOnly) {
      onUpload(e);
    }
  };

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setViewerOpen(true);
  };

  const handleCloseViewer = () => {
    setViewerOpen(false);
  };

  return (
    <div className="ground-images-component">
      <div className="ground-images-grid">
        {images.length === 0 && (
          <div className="ground-images-empty">No images</div>
        )}
        {images.map((img, idx) => (
          <div key={img.id || idx} className={`ground-image-card${img.is_primary ? ' primary' : ''}`}>
            <img 
              src={img.image} 
              alt={`${title} ${idx + 1}`} 
              className="ground-image-thumb" 
              onClick={() => handleImageClick(idx)}
              style={{ cursor: 'pointer' }}
            />
            {!readOnly && (
              <div className="ground-image-actions">
                {!img.is_primary && (
                  <button
                    type="button"
                    className="ground-image-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      onSetPrimary && onSetPrimary(idx);
                    }}
                    title="Set as primary"
                    disabled={loading}
                  >
                    <IoStar size={16} />
                  </button>
                )}
                <button
                  type="button"
                  className="ground-image-btn delete-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete && onDelete(idx);
                  }}
                  title="Delete image"
                  disabled={loading}
                >
                  <IoTrash size={16} />
                </button>
              </div>
            )}
            {img.is_primary && <div className="ground-image-badge">Primary</div>}
          </div>
        ))}
      </div>
      {!readOnly && (
        <div className="ground-images-upload">
          <label className="ground-images-upload-label">
            <IoCloudUpload className="upload-icon" />
            <span>Upload Images</span>
            <input
              type="file"
              multiple
              accept="image/jpeg,image/png,image/gif"
              className="ground-images-file-input"
              onChange={handleFileChange}
              disabled={loading}
            />
          </label>
        </div>
      )}
      
      {/* Display validation errors */}
      {errors && errors.length > 0 && (
        <div className="image-errors">
          {errors.map((error, index) => (
            <div key={index} className="error-message image-error">
              {error.file}
            </div>
          ))}
        </div>
      )}

      {/* Image Viewer Modal */}
      <ImageViewer
        images={images}
        currentIndex={currentImageIndex}
        isOpen={viewerOpen}
        onClose={handleCloseViewer}
        title={title}
      />
    </div>
  );
}

export default MultiImages;